































import { Component, Prop, Vue } from "vue-property-decorator";
import Entry from "@/models/Entry";
import EntryItem from "@/components/EntryItem.vue";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import { Company, Brand, Product } from "@/models";

@Component({
  components: {
    LogoWithFallback,
    EntryItem,
  },
})
export default class EntryList extends Vue {
  @Prop() readonly title?: string;
  @Prop({ default: "small" }) readonly size?: string;
  @Prop() readonly items!: Entry[];
  @Prop() readonly canAdd?: (item: Entry) => boolean;
  @Prop({ default: true }) readonly actions?: boolean;
  @Prop({ default: false }) readonly selectable?: boolean;

  add(value: Company | Brand | Product) {
    this.$emit("add", value);
  }

  remove(value: Company | Brand | Product) {
    this.$emit("remove", value);
  }

  select(value: Company | Brand | Product) {
    if (this.selectable === false) {
      return;
    }

    this.$emit("selected", value);
  }

  getWrapperClass() {
    const classes: string[] = [];

    classes.push(`entry-list--${this.size}`);

    if (this.selectable) {
      classes.push("entry-list--selectable");
    }

    return classes;
  }
}
